import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { addRma as addRmaApi, AddRmaApiParameter } from "@insite/client-framework/Services/OrderService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { RmaLineDto, RmaModel } from "@insite/client-framework/Types/ApiModels";

type SendRmaRequestParameter = {
    orderNumber: string;
    onError?: (errorMessage: string) => void;
} & HasOnSuccess<RmaModel>;

type HandlerType = ApiHandlerDiscreteParameter<SendRmaRequestParameter, AddRmaApiParameter, ServiceResult<RmaModel>>;

export const PopulateApiParameterExtended: HandlerType = props => {
    const state = props.getState();
    const orderLines = state.pages.requestRma.orderLines;
    if (orderLines.length === 0) {
        return false;
    }

    props.apiParameter = {
        rmaModel: {
            orderNumber: props.parameter.orderNumber,
            notes: state.pages.requestRma.returnNotes || "",
            rmaLines: orderLines
                .filter(orderLine => orderLine.rmaQtyReceived > 0 && orderLine.rmaQtyRequested !== orderLine.qtyOrdered)
                .map(orderLine => {
                    return {
                        line: orderLine.lineNumber,
                        rmaQtyRequested: orderLine.rmaQtyReceived,
                        rmaReasonCode: orderLine.returnReason,
                    } as RmaLineDto;
                }),
        } as RmaModel,
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
